import React from "react";

import { useFormikField } from "./useFormikField";

export interface IWithFormikFieldProps {
  name: string;
}

export interface IInjectedFormikFieldProps<Value = any> {
  onBlur?: (event?: any) => void;
  onChange?: (value: Value, event?: any) => void;
  name?: string;
  value?: Value;
  invalid?: boolean;
}

export const withFormikField =
  <P extends IInjectedFormikFieldProps<V>, V = any>(
    Component: React.ComponentType<P>,
  ): React.FC<Omit<P, "value"> & { value?: P["value"] } & IWithFormikFieldProps> =>
  ({ onBlur, onChange, name, ...rest }: P & IWithFormikFieldProps) => {
    const { isErrorVisible, handleBlur, handleChange, value } = useFormikField<V>({ name, onChange, onBlur });

    return (
      <Component
        value={value}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        invalid={isErrorVisible}
        {...(rest as P)}
      />
    );
  };
